import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    club: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setDone(true);
      toast.success("Message sent. We'll get back to you.");
      setForm({ name: "", email: "", club: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass relative w-full overflow-hidden p-8 md:p-10" data-testid="contact-card">
      <div className="pointer-events-none absolute -left-20 -bottom-20 h-60 w-60 rounded-full bg-[#00e5ff]/20 blur-3xl" />
      <div className="relative">
        <div className="label-mono">02 / Clubs &amp; Teams</div>
        <h3 className="font-display mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
          Talk to us
        </h3>
        <p className="mt-3 max-w-md text-sm text-white/60">
          Equipping a club, race series or academy? Tell us about your setup
          and we&apos;ll prepare a pilot package for you.
        </p>

        {done ? (
          <div
            data-testid="contact-success"
            className="mt-8 border border-[#00e5ff]/30 bg-[#00e5ff]/5 px-5 py-4"
          >
            <div className="label-mono">Received</div>
            <p className="mt-2 text-sm text-white/80">
              Thanks — we&apos;ll be in touch within a few days.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div className="grid gap-3 sm:grid-cols-2">
              <input
                required
                value={form.name}
                onChange={update("name")}
                placeholder="Name"
                data-testid="contact-name-input"
                className="border border-white/10 bg-black/40 px-4 py-3 font-mono text-sm text-white placeholder:text-white/30 focus:border-[#00e5ff] focus:outline-none focus:ring-1 focus:ring-[#00e5ff]"
              />
              <input
                required
                type="email"
                value={form.email}
                onChange={update("email")}
                placeholder="Email"
                data-testid="contact-email-input"
                className="border border-white/10 bg-black/40 px-4 py-3 font-mono text-sm text-white placeholder:text-white/30 focus:border-[#00e5ff] focus:outline-none focus:ring-1 focus:ring-[#00e5ff]"
              />
            </div>
            <input
              value={form.club}
              onChange={update("club")}
              placeholder="Club / Organization (optional)"
              data-testid="contact-club-input"
              className="w-full border border-white/10 bg-black/40 px-4 py-3 font-mono text-sm text-white placeholder:text-white/30 focus:border-[#00e5ff] focus:outline-none focus:ring-1 focus:ring-[#00e5ff]"
            />
            <textarea
              required
              rows={4}
              value={form.message}
              onChange={update("message")}
              placeholder="What are you trying to capture? Tell us about your training setup."
              data-testid="contact-message-input"
              className="w-full resize-none border border-white/10 bg-black/40 px-4 py-3 font-mono text-sm text-white placeholder:text-white/30 focus:border-[#00e5ff] focus:outline-none focus:ring-1 focus:ring-[#00e5ff]"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="contact-submit-button"
              className="btn-secondary w-full px-6 py-3 font-mono text-xs uppercase tracking-[0.22em] disabled:opacity-60"
            >
              {loading ? "Sending…" : "Send Message →"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
